var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-steps",class:{'last-current':_vm.status==1}},[_c('img',{staticClass:"steps-icon",attrs:{"src":_vm.currentStep.src,"alt":""}}),_c('div',{staticClass:"line",style:({backgroundColor:_vm.currentStep.color})}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }